const BASE_URL = 'https://api.easyllama.com/helpline';

const headers = {
  'Content-Type': 'application/json',
};

const fixSrc = ( src ) => {
  return window.location.hostname === 'localhost' && window.location.port === '3000'
    ? src.replace('https://api.easyllama.com', 'http://localhost:3000')
    : src
};

const apiService = {
  get: (url, token, signal) => {

    const requestHeaders = {
      ...headers,
      ...(token && { 'Authorization': `Bearer ${token}` }),
    };

    const requestOptions = {
      method: 'GET',
      headers: requestHeaders,
      // Avoid 304 + empty body: response.json() then fails or yields no `case` / `form`.
      cache: 'no-store',
    };

    if (signal) {
      requestOptions.signal = signal;
    }

    return fetch(fixSrc(`${BASE_URL}${url}`), requestOptions).then(async (response) => {
      const text = await response.text();
      if (!text) {
        return {};
      }
      try {
        return JSON.parse(text);
      } catch {
        return {};
      }
    });
  },
  post: (url, data, token, isFile) => {
    const requestHeaders = isFile ? {
      ...(token && { 'Authorization': `Bearer ${token}` })
    } : {
      ...headers,
      ...(token && { 'Authorization': `Bearer ${token}` }),
    };

    return fetch(fixSrc(`${BASE_URL}${url}`), {
      method: 'POST',
      headers: requestHeaders,
      body: isFile ? data : JSON.stringify(data),
    }).then((response) => {
      if (response) {
        return response.json();
      }
    }).catch(err => {
      console.log('err POST > ', err);
    });
  },
};

export default apiService;
